/* Traçabilité V2 — motion layer
   - Scroll reveal (IO)
   - Count-up stats
   - Page progress bar (scroll-linked)
   - Parallax (scroll-linked translateY)
   - Word-by-word split + stagger reveal
*/
(function () {
  "use strict";

  var motionOK = !window.matchMedia || !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ------- 1. Reveal on scroll ------- */
  var revealEls = document.querySelectorAll(".tr2-reveal");
  if (revealEls.length && "IntersectionObserver" in window && motionOK) {
    var ioReveal = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            ioReveal.unobserve(e.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: "0px 0px -60px 0px" }
    );
    revealEls.forEach(function (el) { ioReveal.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-in"); });
  }

  /* ------- 2. Count-up ------- */
  var countEls = document.querySelectorAll("[data-countup]");
  if (countEls.length && "IntersectionObserver" in window && motionOK) {
    var parseTarget = function (str) {
      var clean = str.replace(/[^\d.,]/g, "").replace(/\s/g, "").replace(",", ".");
      var n = parseFloat(clean);
      return isNaN(n) ? 0 : n;
    };
    var formatNum = function (n, template) {
      var rounded = Math.round(n);
      var str = rounded.toString();
      // French thousand space separator
      str = str.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      // Rebuild by replacing digit/space run in original template
      return template.replace(/[\d\s.,]+/, str);
    };
    var runCount = function (el) {
      var raw = el.getAttribute("data-countup");
      var target = parseTarget(raw);
      var duration = 1600;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = formatNum(target * eased, raw);
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = raw;
      }
      requestAnimationFrame(step);
    };
    var ioCount = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            runCount(e.target);
            ioCount.unobserve(e.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    countEls.forEach(function (el) { ioCount.observe(el); });
  }

  /* ------- 3. Page progress bar ------- */
  if (motionOK && document.querySelector(".tr2-zone")) {
    var progress = document.createElement("div");
    progress.className = "tr2-progress";
    progress.setAttribute("aria-hidden", "true");
    document.body.appendChild(progress);

    var progressRaf = false;
    var updateProgress = function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var pct = max > 0 ? h.scrollTop / max : 0;
      progress.style.transform = "scaleX(" + Math.max(0, Math.min(1, pct)) + ")";
      progressRaf = false;
    };
    window.addEventListener(
      "scroll",
      function () {
        if (!progressRaf) {
          requestAnimationFrame(updateProgress);
          progressRaf = true;
        }
      },
      { passive: true }
    );
    updateProgress();
  }

  /* ------- 4. Scroll-linked parallax ------- */
  var parallaxEls = document.querySelectorAll("[data-tr2-parallax]");
  if (parallaxEls.length && motionOK) {
    var pxRaf = false;
    var vh = window.innerHeight;
    var updateParallax = function () {
      parallaxEls.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        // progress in viewport: -1 (below) → 0 (center) → 1 (above)
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        progress = Math.max(-1, Math.min(1, progress));
        var amt = parseFloat(el.getAttribute("data-tr2-parallax")) || 30;
        var rot = parseFloat(el.getAttribute("data-tr2-parallax-rot")) || 0;
        el.style.setProperty("--tr2-px", progress * amt + "px");
        el.style.setProperty("--tr2-prot", progress * rot + "deg");
      });
      pxRaf = false;
    };
    window.addEventListener(
      "scroll",
      function () {
        if (!pxRaf) { requestAnimationFrame(updateParallax); pxRaf = true; }
      },
      { passive: true }
    );
    window.addEventListener("resize", function () {
      vh = window.innerHeight;
      if (!pxRaf) { requestAnimationFrame(updateParallax); pxRaf = true; }
    });
    updateParallax();
  }

  /* ------- 5. Word split + stagger ------- */
  var splitEls = document.querySelectorAll("[data-tr2-split]");
  splitEls.forEach(function (el) {
    if (el.dataset.tr2Split === "done") return;
    var text = el.textContent;
    var words = text.split(/(\s+)/);
    el.innerHTML = "";
    var idx = 0;
    words.forEach(function (w) {
      if (/^\s+$/.test(w)) {
        el.appendChild(document.createTextNode(w));
      } else if (w) {
        var span = document.createElement("span");
        span.className = "tr2-word";
        span.style.setProperty("--i", idx);
        // keep accessible: wrap inner for clip
        var inner = document.createElement("span");
        inner.className = "tr2-word__inner";
        inner.textContent = w;
        span.appendChild(inner);
        el.appendChild(span);
        idx++;
      }
    });
    el.dataset.tr2Split = "done";
  });
  if (motionOK && "IntersectionObserver" in window && splitEls.length) {
    var ioSplit = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-lit");
            ioSplit.unobserve(e.target);
          }
        });
      },
      { threshold: 0.25 }
    );
    splitEls.forEach(function (el) { ioSplit.observe(el); });
  } else {
    splitEls.forEach(function (el) { el.classList.add("is-lit"); });
  }
})();
